// @flow

import { routes } from 'src/routes';

export const GroupStandardSearchRoute = [
  // Relevance
  {
    route: routes.relevanceSettings.view(),
    label: 'Standard search relevance settings'
  },
  // ISW
  {
    route: routes.instantSearchWidget.view(),
    label: 'Standard search ISW'
  },
  // Search result page
  {
    route: routes.searchResultsPage.view(),
    label: 'Standard search Search result page'
  },
  // In collection search
  {
    route: routes.inCollectionSearch.view(),
    label: 'Standard search In-collection search'
  },
  // Synonym
  {
    route: routes.synonym.view(),
    label: 'Standard search synonym'
  },
  {
    route: routes.synonym.new(),
    label: 'Standard search new Synonym'
  },
  {
    route: routes.synonym.edit(),
    label: 'Standard search edit Synonym'
  },
  // Suggestion dictionary
  {
    route: routes.suggestionDictionary.view(),
    label: 'Standard search SuggestionDictionary'
  },
  {
    route: routes.suggestionDictionary.new(),
    label: 'Standard search new SuggestionDictionary'
  },
  {
    route: routes.suggestionDictionary.edit(),
    label: 'Standard search edit SuggestionDictionary'
  },
  // Redirect
  {
    route: routes.redirect.view(),
    label: 'Standard search redirect'
  },
  {
    route: routes.redirect.new(),
    label: 'Standard search new redirect'
  },
  {
    route: routes.redirect.edit(),
    label: 'Standard search edit redirect'
  },
  // Stop words
  {
    route: routes.stopWords.view(),
    label: 'Standard search Stop words'
  }
];

export const GroupNewInstallSetupThemeOnboardingRoute = [
  {
    route: routes.newInstallation.selectFeature(),
    label: 'Onboarding - Select features'
  },
  {
    route: routes.newInstallation.selectThemeNewSimplify(),
    label: 'Onboarding - Select theme'
  },
  {
    route: routes.newInstallation.selectThemeNewSimplifyRunning(),
    label: 'Onboarding - Select theme running sync'
  },
  {
    route: routes.newInstallation.selectTemplate(),
    label: 'Onboarding - Select template'
  },
  {
    route: routes.newInstallation.enableBoostCore(),
    label: 'Onboarding - Enable Boost Core'
  }
];

export const GroupAdvancedSearchRoute = [
  // General
  {
    route: routes.generalAdvancedSearch.view(),
    label: 'Advanced search - general'
  },
  // AI Synonym
  {
    route: routes.aiSynonym.view(),
    label: 'Advanced search AI Synonym'
  },
  // Semantic search
  {
    route: routes.semanticSearch.view(),
    label: 'Advanced search Semantic search'
  },
  // Product performance ranking
  {
    route: routes.productPerformanceRanking.view(),
    label: 'Advanced search product performance ranking'
  },
  // Product performance ranking
  {
    route: routes.searchPersonalization.view(),
    label: 'Personalization'
  }
];

export const GroupShopifyIntegrationRoute = [
  {
    route: routes.shopifyIntegration.view(),
    label: 'Shopify Integration'
  },
  {
    route: routes.shopifyIntegration.viewThemeWidget(':themeId'),
    label: 'Shopify Integration Edit'
  },
  {
    route: routes.shopifyIntegration.newThemeWidget(':themeId'),
    label: 'Shopify Integration New'
  },
  {
    route: routes.newInstallation.viewSetupTheme(':themeId'),
    label: 'Onboarding - Shopify Integration Edit'
  },
  {
    route: routes.newInstallation.setupTheme(':themeId'),
    label: 'Onboarding - Shopify Integration New'
  },
  {
    route: routes.shopifyIntegration.shopifyIntegrationNewSimplify(':themeId'),
    label: 'Shopify Integration New Flow Create'
  },
  {
    route: routes.shopifyIntegration.viewShopifyIntegrationSimplify(':themeId'),
    label: 'Shopify Integration New Flow'
  },
  {
    route: routes.shopifyIntegration.upgradeToTurbo(':themeId'),
    label: 'Shopify Integration Upgrade To Turbo'
  }
];

export const GroupThemeSettingVisualEditorRoute = [
  {
    route: routes.themeSetting.visualEditorModalContent(':themeId'),
    label: 'Theme Setting Visual Editor Modal Content'
  },
  {
    route: routes.themeSetting.visualEditor(':themeId'),
    label: 'Theme Setting Visual Editor'
  }
];

export const GroupShopifyIntegrationSettingsVisualEditorRoute = [
  {
    route: routes.shopifyIntegrationSettings.visualEditorModalContent(':templateId'),
    label: 'Shopify Integration Settings Visual Editor Modal Content'
  },
  {
    route: routes.shopifyIntegrationSettings.visualEditor(':templateId'),
    label: 'Shopify Integration Settings Visual Editor'
  }
];

export const GroupShopifyIntegrationFullscreenRoute = [
  {
    route: routes.shopifyIntegration.codeEditorModalContent(':templateId'),
    label: 'Shopify Integration Code Editor Modal Content'
  },
  {
    route: routes.shopifyIntegration.codeEditor(':templateId'),
    label: 'Shopify Integration Code Editor'
  },
  {
    route: routes.shopifyIntegration.previewBoostTemplateModalContent(':themeNameLib'),
    label: 'Shopify Integration Preview Boost Template Modal Content'
  },
  {
    route: routes.shopifyIntegration.previewBoostTemplate(':themeNameLib'),
    label: 'Shopify Integration Preview Boost Template'
  },
  {
    route: routes.shopifyIntegration.guideModalContent(':themeId', ':templateId', ':feature'),
    label: 'Shopify Integration Guide Modal Content'
  },
  {
    route: routes.shopifyIntegration.guide(':themeId', ':templateId', ':feature'),
    label: 'Shopify Integration Guide'
  }
];
